import { HouseholdType } from "./types/leadWizard";

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export const OPTIONS: { type: HouseholdType; icon: string }[] = [
  { type: "SOLTERO", icon: "👤" },
  { type: "PAREJA", icon: "👥" },
  { type: "FAMILIA", icon: "👨‍👩‍👧" },
];
